import { Box, Typography, TextField, Button } from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { securityApi } from 'hooks/api/security'
import { isDev } from 'hooks/helper/env'

export default function LoginPage() {
  const navigate = useNavigate()
  const { t } = useTranslation(['page-login', 'common'])
  const [isLogined, setIsLogined] = useState<boolean>(false)
  const [id, setId] = useState('')
  const [password, setPassword] = useState('')
  const hasPrompted = useRef(false)

  useEffect(() => {
    // Strict Mode対策: 初回のみ実行
    if (hasPrompted.current) return
    hasPrompted.current = true

    const password = prompt('Enter password:')
    // 開発環境で未入力の場合: ユーザーIDを選択してログイン
    if (isDev && !password) {
      const userId = prompt('Enter user ID:', 'security_company_branch_1_1')
      if (userId) {
        securityApi()
          .signIn(userId, 'password')
          .then(() => {
            location.href = '/assign'
          })
      }
      return
    }
    // パスワード入力ありの場合: Kumocan認証
    securityApi()
      .authKumocan(password || '')
      .then(() => {
        setIsLogined(true)
      })
      .catch(() => {
        navigate('/top')
      })
  }, [navigate])

  const handleSubmit = () => {
    securityApi()
      .signIn(id, password)
      .then(() => {
        location.href = '/assign'
      })
  }

  return (
    <Box
      sx={{
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        backgroundColor: '#f5f5f5',
        gap: 2,
      }}
    >
      {isLogined ? (
        <>
          <Typography variant="h4" component="h1">
            {t('title')}
          </Typography>
          <TextField
            label={t('fields.id')}
            variant="outlined"
            value={id}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setId(e.target.value)
            }
            fullWidth
          />
          <TextField
            label={t('fields.password')}
            variant="outlined"
            type="password"
            value={password}
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              setPassword(e.target.value)
            }
            fullWidth
          />
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            {t('submit_button')}
          </Button>
        </>
      ) : (
        <Typography variant="h6" color="textSecondary">
          {t('authenticating')}
        </Typography>
      )}
    </Box>
  )
}
